import $ from 'jquery';
import './lib_jquery.accessible.autocomplete.list.aria';
import './lib_jquery.json.to.datalist';

export default function autocomplete() {
    $(document).ready(() => {
        $('.js-combobox-1').accessibleCombobox();
        $('.js-combobox-2').jsonToDatalist({
            callback: function(obj) {
                obj.accessibleCombobox({
                    comboboxPrefixClass: 'combobox',
                    comboboxHelpText: 'Utilisez les touches de tabulation ou la flèche du bas pour naviguer dans la liste du champ autocomplété. Confirmez votre choix avec la touche entrée, ou la touche échap pour fermer la liste de suggestions.',
                    defaultClassForInvisibleText: 'invisible',
                    suggestionSingle: 'Il y a ',
                    suggestionPlural: 'Il y a ',
                    suggestionWord: 'suggestion',
                    comboboxButtonTitle: 'Effacer ce champ',
                    comboboxButtonClearText: '<span class="fal fa-times" aria-hidden="true" title="Effacer ce champ"></span><span class="sr-only">Effacer ce champ</span>',
                    comboboxCaseSensitive: 'no',
                    comboboxMinLength: 0,
                    comboboxLimitNumberSuggestions: 666,
                    comboboxSearchOption: 'containing',
                    comboboxSeeMoreText: 'Plus de résultats…'
                });
            },
        });
        $('.js-combobox-3').jsonToDatalist({
            jsonPath: 'http://www.mocky.io/v2/5ab3e1ed2f00006000ca39f3',
            callback: function (obj) {
                obj.accessibleCombobox();
            },
        });
    });
}

